import React from "react";
import {Route, Switch} from "react-router-dom";
import InternalFilteredMentorList from "../../../../modules/InternalFilteredMentorList/InternalFilteredMentorList";
import {ProductOpenedEventWrapper} from "../../../../shared/components/ProductOpenedEventWrapper";

const InternalMentorCardWidgetRoutes = (parentProps) => (
    <Switch>
        <Route
            exact
            path={`${parentProps.match.path}/buddies/:filter/:value+`}
            render={(props) => (
                <ProductOpenedEventWrapper>
                    <InternalFilteredMentorList {...parentProps} {...props} />
                </ProductOpenedEventWrapper>
            )}
        />
    </Switch>
);

export default InternalMentorCardWidgetRoutes;
